import { ModuleWithProviders, NgModule } from '@angular/core';
import {
  BreadcrumbComponent,
  ValidationErrorComponent,
  LogoComponent,
  NavItemsComponent,
  CurrentUserComponent,
  LanguagesComponent,
  PageAlertContainerComponent,
  RoutesComponent,
  AuthWrapperComponent,
  TenantBoxComponent,
} from './components';
import {
  AccountLayoutComponent,
  ApplicationLayoutComponent,
  EmptyLayoutComponent,
  CoachingLayoutComponent
} from './layouts';

import {
  BASIC_THEME_NAV_ITEM_PROVIDERS,
  BASIC_THEME_STYLES_PROVIDERS,
  BASIC_THEME_USER_MENU_PROVIDERS,
  BASIC_THEME_LAYOUT_PROVIDERS
} from './providers';

import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { RouterModule } from '@angular/router';
import { NgbCollapseModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { provideThemeBasicConfig } from './providers';

export const LAYOUTS = [ApplicationLayoutComponent, AccountLayoutComponent, EmptyLayoutComponent, CoachingLayoutComponent];

export const THEME_BASIC_COMPONENTS = [
  ...LAYOUTS,
  // Add new upstream standalone components
  LogoComponent,
  NavItemsComponent,
  CurrentUserComponent,
  LanguagesComponent,
  PageAlertContainerComponent,
  RoutesComponent,
  AuthWrapperComponent,
  TenantBoxComponent,
];

@NgModule({
  declarations: [
    // Only declare layout components (non-standalone)
    ...LAYOUTS
  ],
  exports: [
    ...THEME_BASIC_COMPONENTS,
    ValidationErrorComponent,
    BreadcrumbComponent
  ],
  imports: [
    CoreModule,
    ThemeSharedModule,
    NgbCollapseModule,
    NgbDropdownModule,
    RouterModule,
    // Standalone components imported (ABP 9.3.5)
    ValidationErrorComponent,
    BreadcrumbComponent,
    LogoComponent,
    NavItemsComponent,
    CurrentUserComponent,
    LanguagesComponent,
    PageAlertContainerComponent,
    RoutesComponent,
    AuthWrapperComponent,
    TenantBoxComponent,
  ],
  providers: [
    ...BASIC_THEME_NAV_ITEM_PROVIDERS,
    ...BASIC_THEME_USER_MENU_PROVIDERS,
    ...BASIC_THEME_STYLES_PROVIDERS,
    ...BASIC_THEME_LAYOUT_PROVIDERS,
  ]
})
export class BaseThemeBasicModule {}

@NgModule({
  exports: [BaseThemeBasicModule],
  imports: [BaseThemeBasicModule],
})
export class ThemeBasicModule {
  /**
   * @deprecated forRoot method is deprecated, use `provideThemeBasicConfig` *function* for config settings.
   */
  static forRoot(): ModuleWithProviders<ThemeBasicModule> {
    return {
      ngModule: ThemeBasicModule,
      providers: [provideThemeBasicConfig()],
    };
  }
}
